import { Box, Flex } from 'reflexbox';
import { GraphQLError } from 'graphql';

import * as graphql from 'generated/graphql';
import Container from 'packages/kakapo-ui-kit/components/grid/Container';
import GraphQLErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/GraphQLErrorMessage';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import NotesMetaEditContainer from 'notes/NotesMetaEditContainer';
import Comments from 'comments/Comments';
import { Separator } from '@treams/treams-ui';

export function NotesDetailContainerWithoutSidebar(props: { id: string; error?: GraphQLError }) {
	const {
		data,
		loading,
		error: noteQueryError,
	} = graphql.useNoteQuery({
		variables: {
			id: props.id,
		},
	});

	const findError = () => {
		if (props.error) {
			return props.error;
		}

		if (noteQueryError) {
			return noteQueryError.graphQLErrors[0];
		}
		return undefined;
	};

	return (
		<Container fluid>
			<Flex justifyContent="flex-start">
				<Box
					width={[12 / 12, 12 / 12, 12 / 12, 9 / 12]}
					maxWidth={['auto', 'auto', 'auto', '700px']}
				>
					<GraphQLErrorMessage error={findError()} />
					{loading && !data && (
						<Flex justifyContent="center" alignItems="center">
							<Spinner isLoading size="18px" />
						</Flex>
					)}
					{data?.note && (
						<>
							<NotesMetaEditContainer note={data.note as graphql.Note} />
							<Separator />
							<Box my={4}>
								{data ? <Comments target={data.note} alignComposer="top" /> : <Comments.Skeleton />}
							</Box>
						</>
					)}
				</Box>
			</Flex>
		</Container>
	);
}
